import { styled } from '@mui/material/styles'

export const OptionRow = styled('div', {
  name: 'OptionRow',
  slot: 'Root',
  skipSx: true,
})`
  display: flex;
  align-items: center;
`
